const DOMCache = {
  labelElements1: null,
  labelElements2: null,
  labelElements3: null,
  productThumbnails: null,
  swiperWrapper: null,
  stickyMedia: null,
  carouselLeft: null,
  carouselRight: null,
  mobilePanelHeading: null,
  mobilePanelContent: null,
  mobileHeadIcon: null,
  desktopPanelHeading: null,
  desktopPanelContent: null,
  desktopHeadIcon: null,
  mobileThumbnails: null,
  mediaBank: null,

  init() {
    this.labelElements1 = document.querySelectorAll('.product-option-inputs-1 label');
    this.labelElements2 = document.querySelectorAll('.product-option-inputs-2 label');
    this.labelElements3 = document.querySelectorAll('.product-option-inputs-3 label');
    this.productThumbnails = document.querySelector('.product_thumbnails_viewport');
    this.swiperWrapper = document.querySelector('.product_media_box_swiper .swiper-wrapper');
    this.stickyMedia = document.querySelector('.sticky-atc-bar__media');
    this.carouselLeft = document.querySelector('.carousel-left-switch-icon');
    this.carouselRight = document.querySelector('.carousel-right-switch-icon');
    this.mobilePanelHeading = document.querySelector('.for-mobile .mopio-panel .mopio-panel-heading');
    this.mobilePanelContent = document.querySelector('.for-mobile .mopio-panel .mopio-panel-content');
    this.mobileHeadIcon = document.querySelector('.for-mobile .mopio-panel .mopio-panel-heading-icon');
    this.desktopPanelHeading = document.querySelector('.for-desktop .mopio-panel .mopio-panel-heading');
    this.desktopPanelContent = document.querySelector('.for-desktop .mopio-panel .mopio-panel-content');
    this.desktopHeadIcon = document.querySelector('.for-desktop .mopio-panel .mopio-panel-heading-icon');
    this.mobileThumbnails = document.querySelectorAll('.product_thumbnails_mobile-item');
    this.mediaBank = document.querySelector('.product__media-bank');
  }
};

let productMediaBoxSwiper = null;
let mobileSwiper = null;
let currentVariant = null;
let curVariantId = null;
let initialVariantId = null;
let productData = {
  desc: '',
  product: null,
  variants: null,
  options: null,
  variantsCustom: null,
  groupedByOption1: null,
  mediaImages: null,
  enableLightbox: false,
  enableVideoLooping: false,
  ugcItems: [],
  soldOutLabel: 'Out of stock'
};

function escapeUgcText(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function createUgcSlide(ugc) {
  var slide = document.createElement('div');
  slide.className = 'swiper-slide';

  var wrapper = document.createElement('div');
  wrapper.className = 'product__media-item product__media-item--ugc';
  wrapper.setAttribute('data-product-media-wrapper', '');

  if (ugc.videoHtml) {
    // Server-rendered video_tag HTML: Shopify already picked the best source.
    wrapper.innerHTML = ugc.videoHtml;
  } else if (ugc.image) {
    var mediaDiv = document.createElement('div');
    mediaDiv.className = 'media';
    if (productData.enableLightbox) mediaDiv.classList.add('media--has-lightbox');

    var linkEl;
    if (productData.enableLightbox) {
      linkEl = document.createElement('a');
      linkEl.href = ugc.image;
      linkEl.className = 'lightbox-image no-transition';
      linkEl.setAttribute('data-pswp-src', ugc.image);
      // buildLightboxDataSource() in this file reads naturalWidth/Height from the
      // loaded <img> first; if the image hasn't loaded yet it parses these attrs,
      // and if both are 0/falsy it falls back to 1600x1600. UGC images are usually
      // portrait (9:16) so the 1600 square fallback is a worst-case, not the norm.
      linkEl.setAttribute('data-pswp-width', '0');
      linkEl.setAttribute('data-pswp-height', '0');
    } else {
      linkEl = document.createElement('div');
    }

    var img = document.createElement('img');
    var sep = ugc.image.indexOf('?') === -1 ? '?' : '&';
    img.src = ugc.image + sep + 'width=1200';
    img.alt = ugc.name ? ugc.name : 'UGC photo';
    img.loading = 'lazy';

    linkEl.appendChild(img);
    mediaDiv.appendChild(linkEl);
    wrapper.appendChild(mediaDiv);
  }

  if (ugc.name || ugc.iconUrl) {
    var caption = document.createElement('span');
    caption.className = 'ugc-caption';
    // Escape iconUrl when concatenating into an HTML attribute — Shopify CDN URLs
    // shouldn't contain quotes, but defense-in-depth against malicious filenames.
    var iconHtml = ugc.iconUrl
      ? '<img src="' + escapeUgcText(ugc.iconUrl) + '" alt="" width="14" height="14" loading="lazy" />'
      : '';
    var nameHtml = ugc.name ? '<span class="ugc-caption__handle">' + escapeUgcText(ugc.name) + '</span>' : '';
    var timeHtml = ugc.time ? '<span class="ugc-caption__time">' + escapeUgcText(ugc.time) + '</span>' : '';
    caption.innerHTML = iconHtml + nameHtml + timeHtml;
    wrapper.appendChild(caption);
  }

  slide.appendChild(wrapper);
  return slide;
}

/**
 * Clone a pre-rendered Stiletto media node from the hidden media bank.
 * Returns a swiper-slide div wrapping the cloned product__media-item,
 * or null if the media ID is not found in the bank.
 */
function cloneMediaBankItem(mediaId) {
  if (!DOMCache.mediaBank) return null;
  // <template> stores content in .content (DocumentFragment)
  var bankContent = DOMCache.mediaBank.content || DOMCache.mediaBank;
  var source = bankContent.querySelector('[data-media-item-id="' + mediaId + '"]');
  if (!source) return null;
  var slide = document.createElement('div');
  slide.className = 'swiper-slide';
  slide.appendChild(source.cloneNode(true));
  return slide;
}

/**
 * Create a PhotoSwipe-compatible slide for custom metafield images
 * (these don't exist in product.media so they aren't in the bank).
 */
function createLightboxSlide(imgUrl, alt) {
  var slide = document.createElement('div');
  slide.className = 'swiper-slide';
  var wrapper = document.createElement('div');
  wrapper.className = 'product__media-item';
  wrapper.setAttribute('data-product-media-wrapper', '');
  var mediaDiv = document.createElement('div');
  mediaDiv.className = 'media';
  if (productData.enableLightbox) {
    mediaDiv.classList.add('media--has-lightbox');
  }
  var linkEl;
  if (productData.enableLightbox) {
    linkEl = document.createElement('a');
    linkEl.href = imgUrl;
    linkEl.className = 'lightbox-image no-transition';
    linkEl.setAttribute('data-pswp-src', imgUrl);
    // Width/height unknown for metafield images; PhotoSwipe will read natural size
    linkEl.setAttribute('data-pswp-width', '1600');
    linkEl.setAttribute('data-pswp-height', '1600');
    linkEl.setAttribute('data-cropped', 'true');
  } else {
    linkEl = document.createElement('div');
  }
  var img = document.createElement('img');
  img.src = imgUrl + '?width=800';
  img.alt = alt || 'Product image';
  img.loading = 'lazy';
  linkEl.appendChild(img);
  mediaDiv.appendChild(linkEl);
  wrapper.appendChild(mediaDiv);
  slide.appendChild(wrapper);
  return slide;
}

/**
 * Mark one option value as sold out. The marker styling lives in
 * product-new-template.css (`label.disabled`); the text added here keeps the
 * state from being conveyed by appearance alone.
 *
 * The state goes in the label's own content, NOT on the radio: the input is
 * `display: none` (product-new-template.css) and `visibility: hidden` (inline,
 * from product-block-variant-picker-new.liquid), so it is absent from the
 * accessibility tree and an aria-label there would never be announced. A
 * visually-hidden span inside the label is read alongside the swatch's alt
 * text; `title` additionally surfaces it as a tooltip for pointer users.
 *
 * Selecting a sold-out value stays allowed on purpose — the buy button then
 * shows the sold-out state — which is why nothing here disables the input.
 */
function setOptionSoldOut(labelEl, soldOut) {
  labelEl.classList.toggle('disabled', soldOut);

  let note = labelEl.querySelector('[data-sold-out-note]');
  if (soldOut) {
    labelEl.title = productData.soldOutLabel;
    if (!note) {
      note = document.createElement('span');
      note.className = 'visually-hidden';
      note.setAttribute('data-sold-out-note', '');
      labelEl.appendChild(note);
    }
    note.textContent = productData.soldOutLabel;
  } else {
    labelEl.removeAttribute('title');
    if (note) note.remove();
  }
}

function updateOptionAvailability(groupedByOption1, list, variantId) {
  if (groupedByOption1 && Object.keys(groupedByOption1).length > 0 && DOMCache.labelElements1) {
    Object.keys(groupedByOption1).forEach((option1Value, index) => {
      const group = groupedByOption1[option1Value];
      const groupLength = group.length;
      const unavailableVariants = group.filter(variant => !variant.available);
      const labelEl = DOMCache.labelElements1[index];

      if (labelEl) {
        setOptionSoldOut(labelEl, groupLength === unavailableVariants.length);
      }
    });
  }

  const groupedByOption2 = list.reduce((acc, variant) => {
    const option2Value = variant.option2;
    if (!acc[option2Value]) acc[option2Value] = [];
    acc[option2Value].push(variant);
    return acc;
  }, {});

  if (groupedByOption2 && Object.keys(groupedByOption2).length > 0 && DOMCache.labelElements2) {
    Object.keys(groupedByOption2).forEach((option2Value, index) => {
      const group = groupedByOption2[option2Value];
      const groupLength = group.length;
      const unavailableVariants = group.filter(variant => !variant.available);
      const labelEl = DOMCache.labelElements2[index];

      if (labelEl) {
        setOptionSoldOut(labelEl, groupLength === unavailableVariants.length);
      }
    });
  }

  const current_group = Object.values(groupedByOption2).find(group => group.some(variant => variant.id === variantId));
  if (current_group && current_group.length > 1 && DOMCache.labelElements3) {
    current_group.forEach((variant, idx) => {
      const labelEl = DOMCache.labelElements3[idx];
      if (labelEl) {
        setOptionSoldOut(labelEl, !variant.available);
      }
    });
  }
}

function createSwiper(groupedByOption1, list, variantId, productVariantsCustom) {
  var slides = [];
  let str_thumbs = '';
  const active_index = 0;

  updateOptionAvailability(groupedByOption1, list, variantId);

  // Build src-to-mediaId lookup from mediaImages (product.media items have media IDs)
  var srcToMediaId = {};
  productData.mediaImages.forEach(function(m) {
    if (m.src) {
      // Normalize: strip protocol and query params for matching
      var normalizedSrc = m.src.replace(/^https?:/, '').split('?')[0];
      srcToMediaId[normalizedSrc] = m.id;
    }
  });

  // --- Build slides: clone from media bank for standard product.media, fallback for custom metafield media ---
  list.forEach((item) => {
    if (item.id === variantId) {
      // Try to clone the featured_image from the media bank (Stiletto media.liquid node)
      if (item.featured_image) {
        // Find the media ID by matching image src
        var normalizedItemSrc = item.featured_image.src.replace(/^https?:/, '').split('?')[0];
        var featuredMediaId = srcToMediaId[normalizedItemSrc];
        var bankSlide = featuredMediaId ? cloneMediaBankItem(featuredMediaId) : null;
        if (bankSlide) {
          slides.push(bankSlide);
        } else {
          // Fallback: create a lightbox-compatible slide from the image URL
          slides.push(createLightboxSlide(item.featured_image.src, item.title));
        }
        str_thumbs += `<div class="product_thumbnail_item active"
          data-slide-index=""
          data-media-item-id="${item.id}"
          data-media-type="image"
        >
          <img src="${item.featured_image.src}?width=50" alt="${item.title}" />
        </div>`;
      }

      if (DOMCache.stickyMedia) {
        const stickyImgSrc = item.featured_image ? `${item.featured_image.src}?width=100` : productData.mediaImages[0]?.src ? `${productData.mediaImages[0].src}?width=100` : '';
        DOMCache.stickyMedia.innerHTML = `<img style="max-width: 100%;max-height: 100%;" src="${stickyImgSrc}" />`;
      }

    }
  });

  // Custom metafield images (not in product.media, so not in bank)
  const current_variant_custom = productVariantsCustom.find(v => v.id === variantId);
  var hasCustomImages = current_variant_custom && current_variant_custom.images && current_variant_custom.images.length > 0;

  if (hasCustomImages) {
    current_variant_custom.images.forEach((img, index) => {
      slides.push(createLightboxSlide(img, 'Product image'));
      str_thumbs += `<div class="product_thumbnail_item"
        data-slide-index="${index}"
        data-media-item-id="${current_variant_custom.id}"
        data-media-type="image"
      >
        <img src="${img}?width=50" loading="lazy" />
      </div>`;
    });
  }

  // Fallback: if no featured_image OR no custom images, show all product.media
  // (skip the featured_image if already rendered above to avoid duplicates)
  if (list[0]?.featured_image == null || !hasCustomImages) {
    var featuredSrc = null;
    // Find the current variant's featured_image src to skip it
    list.forEach(function(item) {
      if (item.id === variantId && item.featured_image) {
        featuredSrc = item.featured_image.src.replace(/^https?:/, '').split('?')[0];
      }
    });

    productData.mediaImages.forEach((mediaItem, index) => {
      // Skip the featured_image that was already added above
      if (featuredSrc && mediaItem.src) {
        var normalizedMediaSrc = mediaItem.src.replace(/^https?:/, '').split('?')[0];
        if (normalizedMediaSrc === featuredSrc) return;
      }

      var bankSlide = cloneMediaBankItem(mediaItem.id);
      if (bankSlide) {
        slides.push(bankSlide);
      } else if (mediaItem.src) {
        slides.push(createLightboxSlide(mediaItem.src, mediaItem.alt));
      }
      const thumbImgSrc = mediaItem.src ? `${mediaItem.src}?width=50` : '';
      str_thumbs += `<div class="product_thumbnail_item ${slides.length === 1 && !featuredSrc ? 'active' : ''}"
          data-slide-index="${index}"
          data-media-item-id="${mediaItem.id}"
          data-media-type="image"
        >
          <img src="${thumbImgSrc}" alt="${mediaItem.alt}" />
        </div>`;
    });
  }

  if (current_variant_custom) {
    // Videos: keep existing HTML approach (not from bank, to avoid Plyr conflicts)
    if (current_variant_custom.videos && current_variant_custom.videos.length > 0) {
      current_variant_custom.videos.forEach((video, index) => {
        // `video.thumb` is resolved server-side (explicit `posters` entry, else the
        // video's own cover image). `posters[index]` is the legacy path and is empty
        // for variants that have videos but no `posters` entry.
        var posterUrl = video.thumb || (current_variant_custom.posters || [])[index] || '';

        var videoSlide = document.createElement('div');
        videoSlide.className = 'swiper-slide';
        var videoWrapper = document.createElement('div');
        videoWrapper.className = 'product__media-item';
        videoWrapper.setAttribute('data-product-media-wrapper', '');
        // Use the server-rendered video_tag HTML so the frontend never has to
        // pick sources itself. video_tag already selects the highest-quality
        // source Shopify provides for this file_reference video.
        videoWrapper.innerHTML = video.html || '';
        videoSlide.appendChild(videoWrapper);
        slides.push(videoSlide);

        str_thumbs += `<div class="product_thumbnail_item"
          data-slide-index="${index}"
          data-media-item-id="${current_variant_custom.id}"
          data-media-type="video"
        >
          <img src="${posterUrl}" alt="Video thumbnail" loading="lazy" />
          <div class="video-indicator-thumb-overlay" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="2" fill="rgba(255,255,255,0.85)"/>
              <polygon points="9,6 18,12 9,18" fill="#333" fill-opacity="0.7"/>
            </svg>
          </div>
        </div>`;
      });
    }
  }

  // UGC (product-level, not variant-scoped — reuses shop_the_feed metaobject).
  // Rendered last to keep product info (images + variant videos) visually separated from social proof.
  if (productData.ugcItems && productData.ugcItems.length > 0) {
    productData.ugcItems.forEach(function(ugc) {
      if (!ugc || !ugc.image) return;
      slides.push(createUgcSlide(ugc));
      var altText = ugc.name || 'UGC photo';
      // Badge priority matches the Liquid initial render:
      //   1. Platform icon (merchant-uploaded) — primary signal of UGC source
      //   2. Video play indicator (only if no platform icon AND item is a video)
      //   3. No badge (plain UGC image without platform metadata)
      var overlayHtml = '';
      if (ugc.iconUrl) {
        overlayHtml = '<div class="ugc-platform-overlay" aria-hidden="true">' +
          '<img src="' + escapeUgcText(ugc.iconUrl) + '" alt="" width="16" height="16" loading="lazy" />' +
          '</div>';
      } else if (ugc.videoHtml) {
        overlayHtml = '<div class="video-indicator-thumb-overlay" aria-hidden="true">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<rect width="24" height="24" rx="2" fill="rgba(255,255,255,0.85)"/>' +
            '<polygon points="9,6 18,12 9,18" fill="#333" fill-opacity="0.7"/>' +
          '</svg></div>';
      }
      var sep = ugc.image.indexOf('?') === -1 ? '?' : '&';
      str_thumbs += '<div class="product_thumbnail_item product_thumbnail_item--ugc"' +
        ' data-media-type="ugc">' +
        '<img src="' + ugc.image + sep + 'width=160" alt="' + escapeUgcText(altText) + '" loading="lazy" width="80" height="80" />' +
        overlayHtml +
        '</div>';
    });
  }

  if (DOMCache.productThumbnails) DOMCache.productThumbnails.innerHTML = str_thumbs;

  // Inject slides as DOM nodes instead of innerHTML.
  // First slide uses Stiletto's built-in shimmer (animation--lazy-load) as loading state.
  if (DOMCache.swiperWrapper) {
    DOMCache.swiperWrapper.innerHTML = '';

    slides.forEach(function(slide, idx) {
      // First visible slide: prioritize loading, let Stiletto shimmer show until ready
      if (idx === 0) {
        var firstImg = slide.querySelector('img');
        if (firstImg) {
          firstImg.removeAttribute('loading');
          firstImg.setAttribute('fetchpriority', 'high');
          // Mark loaded once image is ready — Stiletto shimmer disappears automatically
          var markLoaded = function() {
            slide.querySelectorAll('.animation--lazy-load').forEach(function(el) {
              el.classList.remove('animation--lazy-load');
            });
            slide.querySelectorAll('.image').forEach(function(el) {
              el.classList.add('loaded');
            });
          };
          if (firstImg.complete && firstImg.naturalWidth > 0) {
            markLoaded();
          } else {
            firstImg.addEventListener('load', markLoaded, { once: true });
            firstImg.addEventListener('error', markLoaded, { once: true });
          }
        } else {
          // No image in first slide (e.g. video) — mark loaded immediately
          slide.querySelectorAll('.animation--lazy-load').forEach(function(el) {
            el.classList.remove('animation--lazy-load');
          });
          slide.querySelectorAll('.image').forEach(function(el) {
            el.classList.add('loaded');
          });
        }
      }
      DOMCache.swiperWrapper.appendChild(slide);
    });
  }

  initMediaSwiper(active_index);

  // Rebuild desktop grid after variant change (slides have been rebuilt)
  if (typeof window.__buildDesktopGrid === 'function') window.__buildDesktopGrid();

  bindThumbnailEvents();

  initThumbScrollContainer();

  updateWatchVideoBtn();

  initProductLightbox();
}

// Re-init scroll-container after variant change rebuilds thumbnails
function initThumbScrollContainer() {
  if (typeof window.__thumbScrollInit === 'function') {
    window.__thumbScrollInit();
  }
}

function bindThumbnailEvents() {
  const thumbContainer = DOMCache.productThumbnails;
  if (!thumbContainer) return;

  const newContainer = thumbContainer.cloneNode(true);
  thumbContainer.parentNode.replaceChild(newContainer, thumbContainer);

  DOMCache.productThumbnails = newContainer;

  newContainer.addEventListener('click', function(e) {
    const thumbItem = e.target.closest('.product_thumbnail_item');
    if (!thumbItem) return;

    const thumbItems = Array.from(newContainer.querySelectorAll('.product_thumbnail_item'));
    const index = thumbItems.indexOf(thumbItem);
    if (index === -1) return;

    thumbItems.forEach(item => item.classList.remove('active'));
    thumbItem.classList.add('active');

    if (productMediaBoxSwiper) {
      productMediaBoxSwiper.slideTo(index);
    }
  });
}

/**
 * Custom PhotoSwipe lightbox that supports both images and videos.
 * Replaces Stiletto's default productLightbox() which only handles images.
 * The gallery container uses .lightbox-media-container--new so Stiletto's
 * global init doesn't bind to it.
 *
 * Key design: dataSource is built lazily at click time (not at init time)
 * so that images have already loaded and we can read their real
 * naturalWidth/Height — avoids aspect-ratio distortion on UGC photos.
 */
var _pswpModuleCache = null; // cache the dynamic import

function initProductLightbox() {
  if (!productData.enableLightbox) return;

  var gallery = document.querySelector('.lightbox-media-container--new');
  if (!gallery) return;

  // Pre-load the PhotoSwipe chunk so it's ready when the user clicks
  if (!_pswpModuleCache) {
    _pswpModuleCache = import(flu.chunks.photoswipe);
  }

  // Remove previous click handler by replacing the gallery's event-delegating wrapper
  if (gallery._pswpClickHandler) {
    gallery.removeEventListener('click', gallery._pswpClickHandler);
  }

  gallery._pswpClickHandler = function(e) {
    var lightboxLink = e.target.closest('.lightbox-image');
    if (!lightboxLink) return;
    e.preventDefault();

    var clickedSlide = lightboxLink.closest('.swiper-slide');
    var clickedIdx = slideIndexInGallery(clickedSlide, gallery);
    if (clickedIdx < 0) return;

    // Build dataSource NOW — images are loaded, naturalWidth is available
    var dataSource = buildLightboxDataSource(gallery);
    if (!dataSource.length) return;

    openProductLightbox(dataSource, clickedIdx);
  };

  gallery.addEventListener('click', gallery._pswpClickHandler);
}

/**
 * Scan current gallery slides and build a PhotoSwipe dataSource array.
 * Called at click time so img.naturalWidth/Height are available.
 */
function buildLightboxDataSource(gallery) {
  var dataSource = [];
  var slides = gallery.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  );

  slides.forEach(function(slide) {
    var lightboxLink = slide.querySelector('.lightbox-image');
    var video = slide.querySelector('video');

    if (lightboxLink) {
      var img = lightboxLink.querySelector('img');
      // Prefer naturalWidth (actual loaded size) over data attributes
      var w = (img && img.naturalWidth) || parseInt(lightboxLink.getAttribute('data-pswp-width'), 10) || 0;
      var h = (img && img.naturalHeight) || parseInt(lightboxLink.getAttribute('data-pswp-height'), 10) || 0;
      dataSource.push({
        src: lightboxLink.getAttribute('data-pswp-src') || lightboxLink.href,
        width: w || 1600,
        height: h || 1600,
        type: 'image'
      });
    } else if (video) {
      var sources = [];
      video.querySelectorAll('source').forEach(function(src) {
        sources.push({ url: src.src, type: src.type });
      });
      dataSource.push({
        html: '',
        type: 'video',
        videoSources: sources,
        videoPoster: video.poster || ''
      });
    }
  });

  return dataSource;
}

/**
 * Create a fresh PhotoSwipe instance with the given dataSource and open it.
 * A new instance each time avoids stale-data issues after variant changes.
 */
function openProductLightbox(dataSource, startIndex) {
  _pswpModuleCache.then(function(mod) {
    var PhotoSwipeLightbox = mod.PhotoSwipeLightbox;
    var PhotoSwipe = mod.PhotoSwipe;
    var themeIcons = window.theme && window.theme.icons ? window.theme.icons : {};

    var lightbox = new PhotoSwipeLightbox({
      dataSource: dataSource,
      pswpModule: PhotoSwipe,
      mainClass: 'pswp--product-lightbox',
      bgOpacity: 1,
      arrowPrevSVG: themeIcons.chevron || '',
      arrowNextSVG: themeIcons.chevron || '',
      closeSVG: themeIcons.close || '',
      zoomSVG: themeIcons.zoom || ''
    });

    // --- Video slides: custom rendering ---
    lightbox.on('contentLoad', function(e) {
      var content = e.content;
      if (content.data.type !== 'video') return;
      e.preventDefault();

      var videoEl = document.createElement('video');
      videoEl.controls = true;
      videoEl.playsInline = true;
      videoEl.preload = 'metadata';
      videoEl.style.width = '100%';
      videoEl.style.maxHeight = '100%';
      videoEl.style.objectFit = 'contain';
      if (content.data.videoPoster) videoEl.poster = content.data.videoPoster;

      (content.data.videoSources || []).forEach(function(s) {
        var source = document.createElement('source');
        source.src = s.url;
        source.type = s.type;
        videoEl.appendChild(source);
      });

      content.element = document.createElement('div');
      content.element.className = 'pswp__video-container';
      content.element.style.cssText = 'display:flex;align-items:center;justify-content:center;width:100%;height:100%;background:#000;';
      content.element.appendChild(videoEl);
    });

    // Pause video when swiping away from it
    lightbox.on('contentDeactivate', function(e) {
      if (e.content.data.type !== 'video') return;
      var vid = e.content.element && e.content.element.querySelector('video');
      if (vid) { vid.pause(); vid.currentTime = 0; }
    });

    // Pause all videos when lightbox closes
    lightbox.on('close', function() {
      var vids = document.querySelectorAll('.pswp__video-container video');
      vids.forEach(function(v) { v.pause(); });
    });

    // Hide zoom button on video slides
    lightbox.on('uiRegister', function() {
      lightbox.pswp.on('change', function() {
        var pswp = lightbox.pswp;
        var item = pswp.currSlide && pswp.currSlide.data;
        var zoomBtn = pswp.element && pswp.element.querySelector('.pswp__button--zoom');
        if (zoomBtn) {
          zoomBtn.style.display = (item && item.type === 'video') ? 'none' : '';
        }
      });
    });

    lightbox.init();
    lightbox.loadAndOpen(startIndex);
  });
}

function slideIndexInGallery(slideEl, gallery) {
  if (!slideEl || !gallery) return -1;
  var allSlides = gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
  for (var i = 0; i < allSlides.length; i++) {
    if (allSlides[i] === slideEl) return i;
  }
  return -1;
}

function initMediaSwiper(activeIndex) {
  // Destroy early inline swiper if it exists
  if (window.__earlyProductSwiper) {
    window.__earlyProductSwiper.destroy(true, true);
    window.__earlyProductSwiper = null;
  }
  if (productMediaBoxSwiper) {
    productMediaBoxSwiper.destroy(true, true);
  }

  productMediaBoxSwiper = new Swiper('.product_media_box_swiper', {
    slidesPerView: 1,
    initialSlide: activeIndex,
    navigation: {
      nextEl: '.carousel-right-switch-icon',
      prevEl: '.carousel-left-switch-icon',
    },
    on: {
      slideChange: function () {
        const currentIndex = this.activeIndex;
        const thumbItems = document.querySelectorAll('.product_thumbnail_item');
        if (!thumbItems.length) return;

        pauseNewTplVideos();

        thumbItems.forEach((item, index) => {
          if (index === currentIndex) {
            item.classList.add('active');

            scrollToActiveThumb(item, index);
          } else {
            item.classList.remove('active');
          }
        });

        var watchBtn = document.querySelector('.video-indicator-watch-btn--new-tpl');
        if (watchBtn && watchBtn.style.display !== 'none') {
          watchBtn.style.opacity = currentIndex === 0 ? '1' : '0';
          watchBtn.style.pointerEvents = currentIndex === 0 ? '' : 'none';
        }
      },
    },
  });
}

function scrollToActiveThumb(item, index) {
  const parent = item.parentElement;
  if (!parent) return;

  if (window.innerWidth <= 1024) {
    const itemOffsetLeft = item.offsetLeft;
    const itemWidth = item.offsetWidth;
    const parentWidth = parent.offsetWidth;
    const scrollPosition = itemOffsetLeft - (parentWidth / 2) + (itemWidth / 2);
    parent.scrollTo({ left: scrollPosition, behavior: 'smooth' });
  } else {
    const itemOffsetTop = item.offsetTop;
    const itemHeight = item.offsetHeight;
    const parentHeight = parent.offsetHeight;
    const scrollPosition = itemOffsetTop - (parentHeight / 2) + (itemHeight / 2);
    parent.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  }
}

function updateWatchVideoBtn() {
  var btn = document.querySelector('.video-indicator-watch-btn--new-tpl');
  if (!btn) return;
  var hasVideo = document.querySelector('.product_media_box_swiper .swiper-slide video') !== null;
  var hasFacade = document.querySelector('.product_media_box_swiper .product-video-facade') !== null;
  btn.style.display = (hasVideo || hasFacade) ? '' : 'none';
  btn.style.opacity = '1';
  btn.style.pointerEvents = '';
}

function pauseNewTplVideos() {
  document.querySelectorAll('.product_media_box_swiper .swiper-slide video').forEach(function(video) {
    if (!video.paused) video.pause();
  });
}

function triggerNewTplVideoAutoPlay(slideIndex) {
  pauseNewTplVideos();
  setTimeout(function() {
    var slides = document.querySelectorAll('.product_media_box_swiper .swiper-slide');
    var slide = slides[slideIndex];
    if (!slide) return;
    var video = slide.querySelector('video');
    if (video) {
      video.play().catch(function(e) {
        if (e.name === 'NotAllowedError') {
          video.muted = true;
          video.play().catch(function(e2) {
            console.warn('Video muted autoplay also failed:', e2.message);
          });
        } else {
          console.warn('Video autoplay failed:', e.message);
        }
      });
    }
  }, 500);
}

function getCurVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant') || null;
}

function variantChangeHandler() {
  const pathName = window.location.pathname;
  if (!pathName.startsWith('/products/') && !pathName.startsWith('/collections/')) return;

  const updatedVariantId = getCurVariantId() || initialVariantId;

  if (updatedVariantId !== curVariantId) {
    curVariantId = updatedVariantId;
    const targetVariant = productData.variantsCustom.find(v => v.id + "" === curVariantId);

    if (targetVariant) {
      const panelContent = targetVariant.var_description || productData.desc;
      if (DOMCache.mobilePanelContent) DOMCache.mobilePanelContent.innerHTML = panelContent;
      if (DOMCache.desktopPanelContent) DOMCache.desktopPanelContent.innerHTML = panelContent;
    }
  }
}

// Bridge: variant option inputs in main-product--new live outside the Stiletto
// [data-product-form] form, so Stiletto's ProductForm never wires its change
// listeners and never fires the `variantChange` event the gallery relies on.
// Listen on the section root for option-input changes, resolve the matching
// variant, sync the hidden id input + URL, then dispatch `variantChange`.
function bindOptionInputListeners() {
  const productEl = document.querySelector('.product[data-section-type="product"]');
  if (!productEl || !productData.variants) return;

  productEl.addEventListener('change', function(e) {
    const target = e.target;
    if (!target || target.tagName !== 'INPUT') return;
    if (!target.name || target.name.indexOf('options[') !== 0) return;
    if ((target.type === 'radio' || target.type === 'checkbox') && !target.checked) return;

    // Collect the currently-selected value for each option name (first checked wins
    // because the picker renders the same option group multiple times).
    const selected = new Map();
    productEl.querySelectorAll('input[name^="options"]').forEach(function(input) {
      if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
      const match = input.name && input.name.match(/^options\[(.+)\]$/);
      if (!match) return;
      const name = match[1];
      if (selected.has(name)) return;
      selected.set(name, input.value);
    });

    // Skip the configuration link picker (a fake option that redirects to another
    // product) — it's not in product.options and would never match a variant.
    const realOptions = productData.options || [];
    if (!realOptions.length) return;

    const matched = productData.variants.find(function(variant) {
      for (let i = 0; i < realOptions.length; i++) {
        const optName = realOptions[i].name || realOptions[i];
        const expected = selected.get(optName);
        if (expected == null) return false;
        if (variant['option' + (i + 1)] !== expected) return false;
      }
      return true;
    });

    if (!matched) return;

    // Sync hidden id input(s) so ATC posts the right variant.
    document.querySelectorAll('[data-product-form] [name="id"]').forEach(function(idInput) {
      idInput.value = matched.id;
    });

    // Sync URL ?variant= so refreshes / shares land on the chosen variant.
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    } catch (_) {}

    document.dispatchEvent(new CustomEvent('variantChange', { detail: matched }));
  });
}

function initPanelEvents() {
  const panels = [
    {
      heading: DOMCache.mobilePanelHeading,
      content: DOMCache.mobilePanelContent,
      icon: DOMCache.mobileHeadIcon
    },
    {
      heading: DOMCache.desktopPanelHeading,
      content: DOMCache.desktopPanelContent,
      icon: DOMCache.desktopHeadIcon
    }
  ];

  panels.forEach(panel => {
    if (!panel.heading || !panel.content || !panel.icon) return;

    panel.heading.addEventListener('click', () => {
      if (panel.content.style.display === 'block') {
        panel.content.style.display = 'none';
        panel.icon.style.rotate = '';
      } else {
        panel.content.style.display = 'block';
        panel.icon.style.rotate = '180deg';
      }
    });
  });
}

function initSpecImageLightbox() {
  const links = document.querySelectorAll('.details_faq_item_content_specifications_media .lightbox-image');
  if (!links.length) return;

  if (!_pswpModuleCache) {
    _pswpModuleCache = import(flu.chunks.photoswipe);
  }

  if (document._specImageLightboxBound) return;
  document._specImageLightboxBound = true;

  document.addEventListener('click', function(e) {
    const link = e.target.closest('.details_faq_item_content_specifications_media .lightbox-image');
    if (!link) return;
    e.preventDefault();

    const img = link.querySelector('img');
    const w = (img && img.naturalWidth) || parseInt(link.dataset.pswpWidth, 10) || 1600;
    const h = (img && img.naturalHeight) || parseInt(link.dataset.pswpHeight, 10) || 1600;
    const src = link.dataset.pswpSrc || link.href;

    openProductLightbox([{ src: src, width: w, height: h, type: 'image' }], 0);
  });
}

function syncSpecificationsByVariant(variant) {
  if (!variant) return;
  document.querySelectorAll('.details_faq_item--specifications[data-variant-option-index]').forEach((row) => {
    const idx = parseInt(row.dataset.variantOptionIndex, 10);
    if (isNaN(idx) || idx < 0 || idx > 3) return;
    // 0 = per-variant mode: spec blocks are keyed by the full variant title
    const value = idx === 0 ? variant.title : variant['option' + idx];
    if (value == null) return;
    row.querySelectorAll('.details_faq_item_content_specifications').forEach((block) => {
      block.style.display = block.dataset.variantValue === value ? '' : 'none';
    });
  });
}

function initCarouselArrowEvents() {
  if (DOMCache.carouselLeft) {
    DOMCache.carouselLeft.addEventListener('click', function() {
      const activeThumbnail = document.querySelector('.product-thumbnails__item-link.active');
      if (!activeThumbnail) return;

      const parent = activeThumbnail.parentElement;
      const prevSibling = parent?.previousElementSibling;
      const prevLink = prevSibling?.querySelector('.product-thumbnails__item-link');
      prevLink?.click();
    });
  }

  if (DOMCache.carouselRight) {
    DOMCache.carouselRight.addEventListener('click', function() {
      const activeThumbnail = document.querySelector('.product-thumbnails__item-link.active');
      if (!activeThumbnail) return;

      const parent = activeThumbnail.parentElement;
      const nextSibling = parent?.nextElementSibling;
      const nextLink = nextSibling?.querySelector('.product-thumbnails__item-link');
      nextLink?.click();
    });
  }
}

function initMobileThumbEvents() {
  document.addEventListener('productMediaChange', function(evt) {
    const detailIndex = evt.detail.index;
    if (!DOMCache.mobileThumbnails.length) return;

    DOMCache.mobileThumbnails.forEach((item, index) => {
      if (index === detailIndex) {
        item.classList.add('active');

        const parent = item.parentElement;
        if (parent) {
          const itemOffsetLeft = item.offsetLeft;
          const itemWidth = item.offsetWidth;
          const parentWidth = parent.offsetWidth;
          const scrollPosition = itemOffsetLeft - (parentWidth / 2) + (itemWidth / 2);
          parent.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        }
      } else {
        item.classList.remove('active');
      }
    });
  });

  document.addEventListener('productMediaInit', function(evt) {
    mobileSwiper = evt.detail;
  });

  DOMCache.mobileThumbnails.forEach((item, index) => {
    item.addEventListener('click', function() {
      if (mobileSwiper) {
        mobileSwiper.slideTo(index);
      }
    });
  });
}

const mobileProductContentState = {
  ugcSection: null,
  detailsFaqCollapsed: false,
  syncTimers: [],
};

function isMobileProductLayout() {
  return window.matchMedia('(max-width: 750px)').matches;
}

function collapseDetailsFaqOnMobile() {
  if (!isMobileProductLayout()) {
    mobileProductContentState.detailsFaqCollapsed = false;
    return;
  }
  if (mobileProductContentState.detailsFaqCollapsed) return;

  document.querySelectorAll('.details_faq .details_faq_item').forEach((item) => {
    item.classList.remove('active');
    const content = item.querySelector('.details_faq_item_content');
    if (content) {
      content.style.display = 'none';
    }
  });

  mobileProductContentState.detailsFaqCollapsed = true;
}

function moveShopTheFeedBelowAtc() {
  const ugcSection =
    mobileProductContentState.ugcSection || document.querySelector('.shop-the-Feed-section');
  const productMeta = document.querySelector('.product__meta');
  const productForm = productMeta?.querySelector('.product-form');
  const submitGroup = productMeta?.querySelector('.product-form__controls-group--submit');
  const submitItem = submitGroup?.querySelector('.product-form__item--submit');

  if (!ugcSection || !productMeta) return;

  if (!mobileProductContentState.ugcSection) {
    mobileProductContentState.ugcSection = ugcSection;
  }

  const isMobile = isMobileProductLayout();
  ugcSection.classList.toggle('product__mobile-ugc', isMobile);
  ugcSection.classList.toggle('product__desktop-ugc', !isMobile);

  if (submitItem?.parentNode === submitGroup && submitItem.nextElementSibling !== ugcSection) {
    submitItem.insertAdjacentElement('afterend', ugcSection);
  } else if (productForm?.nextElementSibling !== ugcSection) {
    productForm.insertAdjacentElement('afterend', ugcSection);
  }
}

function syncMobileProductContent() {
  collapseDetailsFaqOnMobile();
  moveShopTheFeedBelowAtc();
}

function scheduleMobileProductContentSyncs() {
  mobileProductContentState.syncTimers.forEach((timerId) => {
    window.clearTimeout(timerId);
  });
  mobileProductContentState.syncTimers = [];

  [0, 250, 800, 1600].forEach((delay) => {
    const timerId = window.setTimeout(syncMobileProductContent, delay);
    mobileProductContentState.syncTimers.push(timerId);
  });
}

(function() {
    DOMCache.init();

    // Sticky ATC "Change" button: theme.js binds [data-change-option-trigger] via
    // querySelector (first match), which lands on the thumbnail media div, leaving
    // the visible Change <button> unbound. Bind it explicitly so desktop users can
    // tap Change to scroll back to the variant selector.
    var stickyChangeBtn = document.querySelector('.sticky-atc-bar button[data-change-option-trigger]');
    if (stickyChangeBtn) {
      stickyChangeBtn.addEventListener('click', function() {
        var variantSelector = document.querySelector('.product__variants-wrapper');
        if (variantSelector) {
          variantSelector.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    const dataEl = document.querySelector('script[type="application/json"][id^="ProductData-"]');
    const bridgeData = JSON.parse(dataEl.textContent);

    productData.desc = bridgeData.description;
    productData.product = bridgeData.product;
    productData.variants = bridgeData.variants;
    productData.options = bridgeData.options;
    productData.mediaImages = bridgeData.mediaImages;
    productData.enableLightbox = bridgeData.enableLightbox || false;
    productData.enableVideoLooping = bridgeData.enableVideoLooping || false;
    productData.variantsCustom = bridgeData.variantsCustom;
    productData.ugcItems = bridgeData.ugcItems || [];
    productData.soldOutLabel = bridgeData.soldOutLabel || productData.soldOutLabel;
    currentVariant = productData.variants[0];

    productData.groupedByOption1 = productData.variants.reduce((acc, variant) => {
      const option1Value = variant.option1;
      if (!acc[option1Value]) acc[option1Value] = [];
      acc[option1Value].push(variant);
      return acc;
    }, {});

    initialVariantId = getCurVariantId() || productData.variants[0].id;
    curVariantId = initialVariantId;

    // Resolve the initial variant
    const variantId = getCurVariantId();
    if (variantId) {
      const variant = productData.product.variants.find(v => v.id == variantId);
      if (variant) {
        currentVariant = variant;
      }
    }

    // Initial load: Liquid already rendered the DOM, just init interactions
    var initialList = productData.groupedByOption1[currentVariant.option1] || productData.groupedByOption1[productData.variants[0].option1];
    updateOptionAvailability(productData.groupedByOption1, initialList, currentVariant.id);
    initMediaSwiper(0);
    if (typeof window.__buildDesktopGrid === 'function') window.__buildDesktopGrid();
    bindThumbnailEvents();
    updateWatchVideoBtn();
    initProductLightbox();

    // Sticky media initial image
    if (DOMCache.stickyMedia) {
      var initialImg = productData.variants.find(function(v) { return v.id == curVariantId; });
      var stickyImgSrc = initialImg && initialImg.featured_image && initialImg.featured_image.src
        ? initialImg.featured_image.src + '?width=100'
        : (productData.mediaImages[0] && productData.mediaImages[0].src ? productData.mediaImages[0].src + '?width=100' : '');
      if (stickyImgSrc) {
        DOMCache.stickyMedia.innerHTML = '<img style="max-width:100%;max-height:100%;" src="' + stickyImgSrc + '" />';
      }
    }

    document.addEventListener('variantChange', (e) => {
      const targetVariant = e.detail;

      if (currentVariant.option1 !== targetVariant.option1) {
        createSwiper(productData.groupedByOption1, productData.groupedByOption1[targetVariant.option1], targetVariant.id, productData.variantsCustom);
      } else {
        createSwiper(productData.groupedByOption1, productData.groupedByOption1[targetVariant.option1], targetVariant.id, productData.variantsCustom);
      }
      currentVariant = targetVariant;

      syncSpecificationsByVariant(targetVariant);
    });

    bindOptionInputListeners();

    initPanelEvents();

    initCarouselArrowEvents();

    initSpecImageLightbox();

    initMobileThumbEvents();

    var watchBtnNewTpl = document.querySelector('.video-indicator-watch-btn--new-tpl');
    if (watchBtnNewTpl) {
      watchBtnNewTpl.addEventListener('click', function(e) {
        e.preventDefault();
        var thumbItems = document.querySelectorAll('.product_thumbnail_item');
        for (var i = 0; i < thumbItems.length; i++) {
          if (thumbItems[i].dataset.mediaType === 'video') {
            if (productMediaBoxSwiper) {
              productMediaBoxSwiper.slideTo(i);
              // Click facade to activate video, or autoplay existing video
              var slides = document.querySelectorAll('.product_media_box_swiper .swiper-slide');
              var facade = slides[i] && slides[i].querySelector('.product-video-facade');
              if (facade) {
                setTimeout(function() { facade.click(); }, 300);
              } else {
                triggerNewTplVideoAutoPlay(i);
              }
            }
            return;
          }
        }
      });
    }

    scheduleMobileProductContentSyncs();
    document.addEventListener('DOMContentLoaded', scheduleMobileProductContentSyncs);
    window.addEventListener('load', scheduleMobileProductContentSyncs);

    let mobileSyncTimeout = null;
    window.addEventListener('resize', function() {
      clearTimeout(mobileSyncTimeout);
      mobileSyncTimeout = window.setTimeout(scheduleMobileProductContentSyncs, 150);
    });

    window.addEventListener("pushState", variantChangeHandler);
    window.addEventListener("replaceState", variantChangeHandler);
    window.addEventListener('popstate', variantChangeHandler);
})();
